import { createFileRoute } from '@tanstack/react-router';

import { OrganizationsPage } from '../modules/organizations/ui/pages/OrganizationsPage';

export const Route = createFileRoute('/_authenticated/super-admin/organizations/')({
  component: OrganizationsPage,
  staticData: {
    breadcrumb: ['Platform', 'Organizations'],
  },
});
